// ハルシネーション検知の機能フラグ（Space単位）。サイドバー等の出し分けに使う。
// BE: GET /spaces/:spaceId/hallucination/flags → { enabled }（無効でも 200 で到達可・FEガード用）。
// fail-close: 未確定（ロード中・spaceId 無し・エラー）は enabled=false 扱いにして、
// 権限の無いユーザーに機能導線を見せない（BE の requireHallucinationEnabled と片側にならないよう整合）。

import { useQuery } from '@tanstack/react-query'
import { getHallucinationFlags } from '@/api/requests/hallucination'

export function useHallucinationFlags(spaceId: string | undefined) {
  const query = useQuery({
    queryKey: ['hallucinationFlags', spaceId],
    queryFn: ({ signal }) => getHallucinationFlags(spaceId as string, signal),
    enabled: !!spaceId,
    staleTime: 5 * 60 * 1000, // フラグは頻繁に変わらない＝5分キャッシュ。
    retry: 1,
  })

  return {
    // 明示的に enabled===true のときのみ有効（未確定は fail-close で false）。
    isEnabled: query.data?.enabled === true,
    isLoading: query.isLoading,
    query,
  }
}
